module.exports = __webpack_public_path__ + "static/images/pilates.deb45fc0dd6cca320e3e85d9ba56b443.svg";